<template>
	<div class="view-index">
		<v v-if="isVerticalScreen()" />
		<h v-else />
	</div>
</template>
<script>
	import {
		mapGetters
	} from 'vuex'
	import H from './H.vue';
	import V from './V.vue';
	export default {
		name: 'List',
		components: {
			H,
			V
		},
		data() {
			return {
				
			}
		},
		methods: {
			...mapGetters(["isVerticalScreen"]),
		}
	}
</script>
<style scoped lang="less">
	.view-index {
		width: 100%;
		
	}
	::v-deep {
		.capsule-dialog {
			position: absolute;
			top: 0;
			left: 0;
			height: calc(30px * var(--scale-rate));
			.park-area-point {
				width: calc(20px * var(--scale-rate));
				height: calc(20px * var(--scale-rate));
				margin-right: calc(5px * var(--scale-rate));
			}
			.capsule {
				height: 30px;
				border-radius: 15px;
				background-color: rgba(0, 104, 255, 0.59);
				font-size: 14px;
				color: #FFFFFF;
				line-height: 30px;
				padding: 0 10px 0 15px;
				transform: scale(var(--scale-rate));
				transform-origin: left center;
			}
			span {
				margin: 0 10px;
			}
		}
		
		.pop-dialog {
			width: calc(189px * var(--scale-rate)); 
			height: calc(275px * var(--scale-rate));
			position: absolute;
			top: 0;
			left: 0;
			z-index: 999;
			.bg {
				width: 100%;
				height: 100%;
				object-fit: cover;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 0;
			}
			.content-wrapper {
				//border: 1px solid #000000;
				position: absolute;
				z-index: 3;
				top: calc(35px * var(--scale-rate));
				left: calc(10px * var(--scale-rate));
				right: calc(10px * var(--scale-rate));
				bottom: calc(10px * var(--scale-rate));
				overflow-x: hidden;
				overflow-y: auto;
				color: rgb(29, 41, 116); 
				//background-color: rgba(255, 255, 255, .8);
				.content {
					width: calc(100% / var(--scale-rate));
					transform: scale(var(--scale-rate));
					transform-origin: left top; 
				}
			}
		}
	}
</style>